import audio from '../../../../assets/audio/kids-tracks/Text15.mp3';

export const step21bridge = {
    id: 21,
    title: 'Most',
    taskText: `
        <p>
            Další duch, těch tu dneska ale je, asi nám chtějí pomoct nebo jsou taky tak zvědaví jako my. 
            Tenhle duch je ale zvláštní. Má v ruce sekeru, že by to byl dřevorubec, co tu pokácel ty stromy? 
            Tak jsem měl pravdu, je to přesně tak. Se svým bratrem tu vykácel všechny stromy a potom udělali, 
            no já to snad ani neřeknu, hroznou lumpárnu. Část toho dřeva totiž ukradli. Za trest tu teď sedí na mostě, 
            který je postavený ze dřeva, které chtěli ukrást. Musí strašit. Říká, že aby nás pustil dál, 
            tak mu musíš říct nějaké svoje tajemství.
        </p>
    `,
    cipher: {
        text: `
            Řekni duchovi svoje tajemství, aby tě pustil dál.
        `,
        label: 'Úkol',
    },
    continueButtonText: 'Hotovo',
    points: true,
    audio: audio,
};
